import { range, uniq } from "lodash";
import { LatLng, moveTo, insidePolygon } from "geolocation-utils";

import { api } from "api";
import { FirebaseBoundary, Iterable } from "types";
import { castBoundary, castDocs } from "utils/helpers";

// radius: number (in meters);
export const incluedInCircle = async (center: LatLng, radius: number) => {
  try {
    // console.log({ center, radius });

    const stepDistance = radius / 10;
    const steps = Array.from(Array(11).keys());
    const distances = steps.map((_, index) => stepDistance * index);
    const headings = range(0, 375, 15);

    const points = steps.map((_, index) => {
      if (index === 0) return [center];

      return headings.map((heading) => {
        const point = moveTo(
          { lat: center.lat, lon: center.lng },
          { heading, distance: distances[index] }
        );
        return { lat: point.lat, lng: point.lon };
      });
    });

    const response = await api.firestore.boundaries.list();
    const firebaseBoundaries = castDocs<Iterable<FirebaseBoundary>>(response);
    const boundaries = firebaseBoundaries.map((item) => castBoundary(item));

    const polygons = boundaries.map((boundary) => {
      let paths: LatLng[][] | LatLng[][] = [];

      if (boundary.geometry.type === "Polygon") {
        const coordinates = boundary.geometry.coordinates as number[][][];
        const values = coordinates.map((item) => {
          return item.map((i) => ({ lat: i[1], lng: i[0] }));
        });
        paths = values;
      } else {
        const coordinates = boundary.geometry.coordinates as number[][][][];
        const values = coordinates.map((coords) => {
          return coords
            .map((i) => i.map((v) => ({ lat: v[1], lng: v[0] })))
            .flat(1);
        });
        paths = values;
      }

      return paths;
    });

    const filteredByPolygons = points.flat(1).map((point) => {
      const data = polygons.map((array, index) => {
        const isInside =
          array.filter((item) => insidePolygon(point, item)).length > 0;

        return isInside ? boundaries[index].isoCode : undefined;
      });

      return data.filter(Boolean) as string[];
    });

    const countries = uniq(filteredByPolygons.flat(1));
    return Promise.resolve(countries);
  } catch (error) {
    return Promise.reject(error);
  }
};
